"use client";

import { ErrorDetails } from "@/components/ErrorDetails";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body>
        <ErrorDetails error={error} reset={reset} where="global-error" />
      </body>
    </html>
  );
}
